import { IPublicClientApplication } from "@azure/msal-browser";

import {
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequestUsingTxtHtml,
} from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import AceiteTermoDTO from "../../model/dto/AceiteTermoDTO";
import { TermoDiretrizEnum } from "../../model/Enums/TermoDiretrizEnum";

const route = "docente/v1/termosdiretrizes/1/conteudohtml/";
const routeAcceptTerms = "/docente/v1/termosdiretrizes";

const getAcceptanceTermsToEditor = (instance: IPublicClientApplication) => {
    return axiosGetRequest(
        route,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

const saveNewAcceptanceTerms = (
    instance: IPublicClientApplication,
    payload: string
) => {
    return axiosPutRequestUsingTxtHtml(
        route,
        payload,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
};

async function getAcceptanceTerms(
    termoDiretriz: TermoDiretrizEnum,
    matriculaDocente: string,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        matricula_docente: matriculaDocente,
    });

    return axiosGetRequest(
        `${routeAcceptTerms}/${termoDiretriz}${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

async function saveUserAcceptance(
    aceiteTermoDTO: AceiteTermoDTO,
    instance: IPublicClientApplication
) {
    return axiosPostRequest(
        `${routeAcceptTerms}/aceite`,
        aceiteTermoDTO,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getAcceptanceTermsToEditor,
    saveNewAcceptanceTerms,
    getAcceptanceTerms,
    saveUserAcceptance,
};
